var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEykoTransform(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.04L7.96 14l.745-.745-.678-.686h2.424a2.126 2.126 0 001.952-1.29c.11-.26.166-.536.166-.828V8.027l.686.678.745-.744L12.04 6l-1.961 1.96.744.745.687-.678v2.424c0 .149-.028.287-.083.413a1.093 1.093 0 01-.563.563 1.026 1.026 0 01-.413.083H8.027l.678-.687-.744-.744L6 12.039z",
    fill: "#323130"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#323130",
    d: "M6.5.5h9v3h-9zM.5 6.5h3v9h-3z"
  })));
}

export default SvgEykoTransform;